import { gql } from '@apollo/client'

import { ProjectFileFragment, ProjectFolderFragment, ProjectFragment } from '../fragments'

export const MUTATION_CREATE_PROJECT = gql`
  mutation createProject($input: ProjectCreateInput!) {
    createProject(input: $input) {
      ...ProjectFragment
    }
  }
  ${ProjectFragment}
`

export const MUTATION_UPDATE_PROJECT = gql`
  mutation updateProject($input: ProjectUpdateInput!) {
    updateProject(input: $input) {
      ...ProjectFragment
    }
  }
  ${ProjectFragment}
`

export const MUTATION_DELETE_PROJECT = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(id: $id)
  }
`

export const MUTATION_CREATE_PROJECT_FILE = gql`
  mutation createProjectFile($input: ProjectFileCreateInput!) {
    createProjectFile(input: $input) {
      ...ProjectFileFragment
    }
  }
  ${ProjectFileFragment}
`

export const MUTATION_UPDATE_PROJECT_FILE = gql`
  mutation updateProjectFile($input: ProjectFileUpdateInput!) {
    updateProjectFile(input: $input) {
      ...ProjectFileFragment
    }
  }
  ${ProjectFileFragment}
`

export const MUTATION_UPDATE_PROJECT_FILE_STATUS = gql`
  mutation updateProjectFileStatus($input: ProjectFileStatusUpdateInput!) {
    updateProjectFileStatus(input: $input) {
      ...ProjectFileFragment
    }
  }
  ${ProjectFileFragment}
`

export const MUTATION_DELETE_PROJECT_FILE = gql`
  mutation deleteProjectFile($input: ProjectFileDeleteInput!) {
    deleteProjectFile(input: $input)
  }
`

export const MUTATION_CREATE_PROJECT_FOLDER = gql`
  mutation createProjectFolder($input: ProjectFolderCreateInput!) {
    createProjectFolder(input: $input) {
      ...ProjectFolderFragment
    }
  }
  ${ProjectFolderFragment}
`

export const MUTATION_UPDATE_PROJECT_FOLDER = gql`
  mutation updateProjectFolder($input: ProjectFolderUpdateInput!) {
    updateProjectFolder(input: $input) {
      ...ProjectFolderFragment
    }
  }
  ${ProjectFolderFragment}
`

export const MUTATION_SET_PROJECT_FOLDER_ROLES = gql`
  mutation setProjectFolderRoles($input: ProjectFolderSetRolesInput!) {
    setProjectFolderRoles(input: $input) {
      ...ProjectFolderFragment
    }
  }
  ${ProjectFolderFragment}
`

export const MUTATION_DELETE_PROJECT_FOLDER = gql`
  mutation deleteProjectFolder($input: ProjectFolderDeleteInput!) {
    deleteProjectFolder(input: $input)
  }
`

export const MUTATION_DUPLICATE_PROJECT_FOLDER = gql`
  mutation duplicateProjectFolder($input: ProjectFolderDuplicateInput!) {
    duplicateProjectFolder(input: $input)
  }
`

export const MUTATION_UPDATE_PROJECT_FILE_ANNOTATIONS = gql`
  mutation updateProjectFileAnnotations($input: ProjectFileUpdateAnnotationsInput!) {
    updateProjectFileAnnotations(input: $input)
  }
`

export const MUTATION_CREATE_PROJECT_FILE_VALIDATION_REQUEST = gql`
  mutation createProjectFileValidationRequest($input: ProjectFileValidationRequestCreateInput!) {
    createProjectFileValidationRequest(input: $input) {
      id
    }
  }
`

export const MUTATION_CANCEl_PROJECT_FILE_VALIDATION_REQUEST = gql`
  mutation cancelProjectFileValidationRequest($input: ProjectFileValidationRequestCancelInput!) {
    cancelProjectFileValidationRequest(input: $input)
  }
`

export const MUTATION_VALID_PROJECT_FILE_VALIDATION_REQUEST_BY_TOKEN = gql`
  mutation validProjectFileValidationRequestByToken($input: ProjectFileValidationRequestValidByTokenInput!) {
    validProjectFileValidationRequestByToken(input: $input)
  }
`

export const MUTATION_VALID_WITH_OBSERVATION_PROJECT_FILE_VALIDATION_REQUEST_BY_TOKEN = gql`
  mutation validWithObservationProjectFileValidationRequestByToken(
    $input: ProjectFileValidationRequestValidWithObservationByTokenInput!
  ) {
    validWithObservationProjectFileValidationRequestByToken(input: $input)
  }
`

export const MUTATION_REFUSE_PROJECT_FILE_VALIDATION_REQUEST_BY_TOKEN = gql`
  mutation refuseProjectFileValidationRequestByToken($input: ProjectFileValidationRequestRefuseByTokenInput!) {
    refuseProjectFileValidationRequestByToken(input: $input)
  }
`

export const MUTATION_IGNORE_PROJECT_FILE_VALIDATION_REQUEST_BY_TOKEN = gql`
  mutation ignoreProjectFileValidationRequestByToken($input: ProjectFileValidationRequestIgnoreByTokenInput!) {
    ignoreProjectFileValidationRequestByToken(input: $input)
  }
`
